import React, { FC, useEffect, useState, useContext } from 'react';
import { connect } from 'react-redux';
import { Form, Select } from 'antd';
import { RootState } from '../../../../../rootReducer';
import { AppDispatch } from '../../../../../store';
import { TurbineStatus } from '../../../../Shared/Landing/Landing.slice';
import { SelectOption } from '../../annotation.types';
import { RouteComponentProps, withRouter } from 'react-router';
import { ParserContext } from '../../../contexts/ParserContext';
import { TurbineStatusInfo, updateTurbineStatus } from './turbineStatus.slice';

type Props = {
  turbineStatusInfo: TurbineStatusInfo | null;
  updatingStatus: boolean;
  setNewStatus: (status: TurbineStatus, turbinePath: string) => void;
};

export const TurbineStatusMenu: FC<RouteComponentProps & Props> = ({ match, turbineStatusInfo, updatingStatus, setNewStatus }) => {
  const [options, setOptions] = useState<SelectOption[]>([]);
  const [currentStatus, setCurrentStatus] = useState<string | null>(null);

  const { parser } = useContext(ParserContext);

  const onChange = (status: string) => {
    const requiredPath = parser.parsedRequiredPath(match.params);
    setNewStatus(Number(status), requiredPath);
  };

  useEffect(() => {
    if (turbineStatusInfo) {
      setOptions(turbineStatusInfo.possibleNextStatuses);
      setCurrentStatus(turbineStatusInfo.status.toString());
    }
  }, [turbineStatusInfo]);

  const newMenuDisabled = !turbineStatusInfo?.canChangeStatus || options.length <= 1;

  return (
    <div className='turbine-status-menu'>
      <Form.Item label='Status:' style={{ fontSize: '1rem', color: '#321850' }}>
        <Select
          disabled={newMenuDisabled}
          loading={updatingStatus || !turbineStatusInfo}
          style={{ width: '95%' }}
          placeholder='Please select'
          optionFilterProp='children'
          onChange={onChange}
          filterOption={true}
          value={currentStatus ? currentStatus : undefined}
        >
          {options.map(option => (
            <Select.Option value={option.value} key={option.value}>
              {option.text}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  turbineStatusInfo: state.turbineStatus.turbineStatusInfo,
  updatingStatus: state.turbineStatus.updatingStatus
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  setNewStatus: (status: TurbineStatus, turbinePath: string) => dispatch(updateTurbineStatus(turbinePath, status))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TurbineStatusMenu));
